/* Load external film players only after a visitor chooses to play. */
class ChiVideo extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    this.addEventListener('click', event => {
      if (!event.target.closest('[data-video-play]')) return;
      const id = this.dataset.videoId;
      if (!id || !/^[A-Za-z0-9_-]{1,30}$/.test(id)) return;
      const frame = document.createElement('iframe');
      if (this.dataset.provider === 'youtube') frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
      else if (this.dataset.provider === 'vimeo') frame.src = `https://player.vimeo.com/video/${id}?dnt=1&autoplay=1`;
      else return;
      frame.title = this.dataset.title || 'CHI film';
      frame.allow = 'autoplay; fullscreen; picture-in-picture';
      frame.allowFullscreen = true;
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      frame.tabIndex = 0;
      this.replaceChildren(frame);
      frame.focus();
    }, { signal: this.abort.signal });
  }
  disconnectedCallback() { this.abort?.abort(); }
}
customElements.define('chi-video', ChiVideo);

// Preserve the stored country when editing classic-account addresses.
function initialiseAddressCountries(root) {
  root.querySelectorAll('[data-address-country]').forEach(select => {
    if (select.dataset.default) select.value = select.dataset.default;
  });
}
initialiseAddressCountries(document);
document.addEventListener('shopify:section:load', event => initialiseAddressCountries(event.target));

// Address deletion is a deliberate second action, like Shopify's standard flow.
document.addEventListener('submit', event => {
  if (event.target.matches('[data-delete-address]') && !window.confirm('Delete this address?')) event.preventDefault();
});
